export const ORDER_HISTORY_FILTERS = {
    ALL: 'ALL',
    DRAFT: 'DRAFT',
    COMPLETED: 'COMPLETED',
    ACCEPTED: 'ACCEPTED',
    PAYMENT_REMAINED: 'PAYMENT_REMAINED',
    TO_BE_ASSESSED: 'TO_BE_ASSESSED',
    REJECTED: 'REJECTED'
}

export const ORDER_HISTORY_STATUS = {
    DRAFT: 'Draft',
    TO_BE_ASSESSED: 'To Be Assessed',
    ACCEPTED: 'Accepted',
    PAYMENT_REMAINED: 'Payment Remained',
    COMPLETED: 'Completed',
    REJECTED: 'Rejected'
};

export const ORDER_HISTORY_STATUS_FOR_ADMIN = {
    TO_BE_ASSESSED: 'To Be Assessed',
    ACCEPTED: 'Accepted',
    COMPLETED: 'Completed',
    REJECTED: 'Rejected'
};

export const REVERSE_MAP_ORDER_HISTORY_STATUS_FOR_ADMIN = {
    'To Be Assessed': 'TO_BE_ASSESSED',
    'Accepted': 'ACCEPTED',
    'Completed': 'COMPLETED',
    'Rejected': 'REJECTED'
}

export const TYPE_SELECTION = {
    OVER_THE_COUNTER: 'Over-The-Counter',
    PRESCRIBED_MEDICATION: 'Prescribed Medication',
    VAPING: 'Vaping | e-Cigarettes',
    COMBINATION_THERAPY: 'Combination Therapy'
}

export const DRUG_SELECTION = {
    nicovape: 'Nicovape',
    BUPROPION: 'Bupropion (Zyban)',
    VARENICLINE: 'Varenicline (Champix)'
}

export const IS_ASSESSMENT_TYPES = {
    SMOKING_CESSATION: "Smoking Cessation",
    MEDICINAL_CANNABIS: "Medicinal Cannabis",
}

export const COUPON_TYPES = {
    INSTANT_CONSULT: "INSTANT_CONSULT",
    INSTANT_SWITCH: "INSTANT_SWITCH",
    INSTANT_LEAF: "INSTANT_LEAF",
    INSTANT_HUSH: "INSTANT_HUSH"
}

export const BRAND_DISPLAY_NAMES = {
    INSTANT_CONSULT: "Instant Consult",
    INSTANT_SWITCH: "Instant Switch",
    INSTANT_LEAF: "Instant Leaf",
    INSTANT_HUSH: "Instant Hush"
  };
  
  export const BANNER_TYPE_CONSULT_DETAILS = {
    NEW: 'NEW',
    COMMING_SOON: 'COMMING_SOON'
};